import React, { Dispatch, SetStateAction } from 'react'

import NumbersRangeSelect from '@components/NumbersRangeSelect'
import { MetaFilterTypes, NumbersRange } from '@modules/search/types'

export interface DateRangeSelectProps {
  eventsDatesRange: NumbersRange
  selectedDateFrom?: number
  selectedDateTo?: number
  setDateRangeSelectEnd: (value: number) => void
  setDateRangeSelectStart: (value: number) => void
  setSelectedType?: Dispatch<SetStateAction<MetaFilterTypes>>
  isSelected?: boolean
  identifier?: string
}

const DateRangeSelect = (props: DateRangeSelectProps) => {
  const {
    eventsDatesRange,
    selectedDateFrom,
    selectedDateTo,
    setDateRangeSelectEnd,
    setDateRangeSelectStart,
    setSelectedType,
    isSelected,
    identifier,
  } = props

  const handleChangeDateRange = (minDate: number, maxDate: number) => {
    if (!isSelected && setSelectedType) {
      setSelectedType(MetaFilterTypes.BY_DATE_RANGE)
    }

    if (minDate !== selectedDateFrom) {
      setDateRangeSelectStart(minDate)
    }

    if (maxDate !== selectedDateTo) {
      setDateRangeSelectEnd(maxDate)
    }
  }

  return (
    <NumbersRangeSelect
      identifier={identifier}
      maxValue={eventsDatesRange.max}
      minValue={eventsDatesRange.min}
      selectedStartValue={selectedDateFrom}
      selectedEndValue={selectedDateTo}
      onChange={handleChangeDateRange}
    />
  )
}

export default DateRangeSelect
